<template>
    <div class="pro-detail">
        <div class="pro-info">
            <img class="item-img" src="../../assets/img/gpt.png" alt="">
            <div class="item-content">
                <div class="pro-name">
                    {{ proDetail.name }}
                    <a-icon @click="changeProName(proDetail.name)" type="edit" />
                </div>
                <div class="pro-id">ID：{{ projectId }}</div>
            </div>
            <div class="item-btn" @click="interactionLearn">
                <a-icon type="edit" />
                <span>完善简历</span>
            </div>
            <div class="item-btn item-btn2" @click="experienceLink">
                <a-icon type="robot" />
                <span>体验链接</span>
            </div>
        </div>
        <div class="page-tab">
            <div :class="currentTab==1?'active':''" @click="selectTab(1)">
                <a-icon type="profile" />
                <span>基础信息</span>
            </div>
            <div :class="currentTab==7?'active':''" @click="selectTab(7)">
                <a-icon type="pull-request" />
                <span>资源包列表</span>
            </div>
            <div :class="currentTab==8?'active':''" @click="selectTab(8)">
                <a-icon type="snippets" />
                <span>扣费日志</span>
            </div>
        </div>
        <div v-if="currentTab==1" class="tab-1">
            <div style="display:flex">
                <div style="height:220px;background:#fff;border:1px solid rgba(229, 231, 235, 1);border-radius:8px;padding:16px 24px;flex:1">
                    <div style="color:rgba(18, 18, 18, 1);font-weight:bold;font-size:18px;">设计信息</div>
                    <a-row style="height:136px;margin-top:17px;">
                        <a-col :span="6" style="height:100%;">
                            <div style="height:100%;border-right:1px solid rgba(229, 229, 229, 1);">
                                <div style="width:100%;height:60px;">
                                    <img style="width:58px;border-radius:29px;border:1px solid rgba(34, 215, 187, 1);float:left;" src="../../assets/img/chart-avatar.png" alt="">
                                    <div style="display:inline-block;margin-left:16px;float:left;">
                                        <div :title="proDetail.name" style="color:rgba(0, 0, 0, 1);font-size:16px;font-weight:bold;padding-top:5px;">{{proDetail.name?(proDetail.name.length>10?proDetail.name.substring(0,10)+'...':proDetail.name):''}}</div>
                                        <div style="color:rgba(158, 172, 196, 1);font-size:14px;">{{proDetail.career}}</div>
                                    </div>
                                </div>
                                <div @click="interactionLearn" style="width:80%;height:60px;line-height:60px;margin:0 auto;cursor:pointer;color:rgba(34, 215, 187, 1);font-size:16px;background:rgba(34, 215, 187, 0.08);border-radius:8px;margin-top:16px;border:1px solid rgba(34, 215, 187, 1);float:left;">
                                    <a-icon style="float:left;margin-top:18px;margin-left:20px;font-size:22px;" type="file-text" />
                                    <span style="color:rgba(18, 18, 18, 1);font-size:16px;margin-left:12px">完善简历</span>
                                    <a-icon style="float:right;margin-top:22px;margin-right:16px" type="right" />
                                </div>
                            </div>
                        </a-col>
                        <a-col :span="9" style="height:100%;">
                            <div style="height:100%;text-align: center;border-right:1px solid rgba(229, 229, 229, 1)">
                                <a-row>
                                    <a-col :span="6">
                                        <div style="color:rgba(18, 18, 18, 1);font-size:13px;">简历字段</div>
                                        <div style="color:rgba(34, 215, 187, 1);font-size:20px;font-weight:bold;margin:4px 0 29px;">{{ proDetail.baseInfoCount }}</div>
                                        <div style="color:rgba(18, 18, 18, 1);font-size:13px;">文本数量</div>
                                        <div style="color:rgba(34, 215, 187, 1);font-size:20px;font-weight:bold;margin:4px 0 0;">{{proDetail.textLength}}</div>
                                    </a-col>
                                    <a-col :span="6">
                                        <div style="color:rgba(18, 18, 18, 1);font-size:13px;">背景信息</div>
                                        <div style="color:rgba(34, 215, 187, 1);font-size:20px;font-weight:bold;margin:4px 0 29px;">{{ proDetail.backgroundInfoCount }}</div>
                                    </a-col>
                                    <a-col :span="6">
                                        <div style="color:rgba(18, 18, 18, 1);font-size:13px;">补充要求</div>
                                        <div style="color:rgba(34, 215, 187, 1);font-size:20px;font-weight:bold;margin:4px 0 29px;">{{proDetail.supplementCount}}</div>
                                    </a-col>
                                </a-row>
                            </div>
                        </a-col>
                        <a-col :span="9" style="height:100%;">
                            <div style="height:100%;padding:0 24px;">
                                <div style="color:rgba(18, 18, 18, 1);font-size:13px;">工作职责</div>
                                <div style="color:rgba(158, 172, 196, 1);font-size:13px;margin-top:15px;">{{proDetail.responsibility}}</div>
                            </div>
                        </a-col>
                    </a-row>
                </div>
            </div>
            <div style="height:214px;padding:16px 24px;background:#fff;margin-top:16px;border:1px solid rgba(229, 231, 235, 1);border-radius:8px">
                <div style="color:rgba(18, 18, 18, 1);font-size:18px;font-weight:bold;">渠道对接</div>
                <div style="display:inline-block;width:200px;height:130px;background:rgba(244, 244, 245, 1);border:1px solid rgba(229, 231, 235, 1);padding:16px 20px;border-radius:8px;margin-top:17px;float:left;">
                    <div>
                        <img style="width:32px;" src="../../assets/img/phone-sence.png" alt="">
                    </div>
                    <div style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;margin:8px 0 16px;">
                        <span style="cursor:pointer;">智能电话</span>
                    </div>
                    <div>
                        <span style="color:rgba(18, 18, 18, 1);font-size:13px">{{proDetail.channel.phone}}</span>
                    </div>
                </div>
                <div style="display:inline-block;width:200px;height:130px;background:rgba(244, 244, 245, 1);border:1px solid rgba(229, 231, 235, 1);padding:16px 20px;margin:17px 16px 0;border-radius:8px;float:left;">
                    <div>
                        <img style="width:32px;" src="../../assets/img/word-sence.png" alt="">
                    </div>
                    <div style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;margin:8px 0 16px;">
                        <span style="cursor:pointer;">文字客服</span>
                    </div>
                    <div>
                        <span style="color:rgba(18, 18, 18, 1);font-size:13px">{{proDetail.channel.text}}</span>
                    </div>
                </div>
                <div style="display:inline-block;width:200px;height:130px;background:rgba(244, 244, 245, 1);border:1px solid rgba(229, 231, 235, 1);padding:16px 20px;border-radius:8px;float:left;margin-top: 17px;">
                    <div>
                        <img style="width:32px;" src="../../assets/img/video-sence.png" alt="">
                    </div>
                    <div style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;margin:8px 0 16px;">
                        <span style="cursor:pointer;">视频客服</span>
                    </div>
                    <div>
                        <span style="color:rgba(18, 18, 18, 1);font-size:13px">{{proDetail.channel.video}}</span>
                    </div>
                </div>
                <div style="display:inline-block;width:200px;height:130px;background:rgba(244, 244, 245, 1);border:1px solid rgba(229, 231, 235, 1);padding:16px 20px;border-radius:8px;float:left;margin-top: 17px;margin-left:16px;">
                    <div>
                        <img style="width:32px;" src="../../assets/img/h5-sence.png" alt="">
                    </div>
                    <div style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;margin:8px 0 16px;">
                        <span style="cursor:pointer;">H5数字人</span>
                    </div>
                    <div>
                        <span style="color:rgba(18, 18, 18, 1);font-size:13px">{{proDetail.channel.h5}}</span>
                    </div>
                </div>
            </div>
            <div style="height:310px;background:#fff;margin-top:16px;border:1px solid rgba(229, 231, 235, 1);border-radius:8px;position:relative;">
                <div style="padding:16px 24px 0">
                    <div style="color:rgba(18, 18, 18, 1);font-size:18px;font-weight:bold;margin-bottom:18px">项目信息与操作</div>
                    <div style="display:inline-block;width:15%;float:left">
                        <div style="color:rgba(18, 18, 18, 1);font-size:14px;">发布与修改时间</div>
                        <div style="color:rgba(18, 18, 18, 1);font-size:14px;margin:24px 0">外链分享权限</div>
                        <div style="color:rgba(18, 18, 18, 1);font-size:14px;">计费策略设定</div>
                        <div style="color:rgba(18, 18, 18, 1);font-size:14px;margin-top:24px;">分享到广场</div>
                    </div>
                    <div style="display:inline-block;width:55%;float:left">
                        <div>
                            <span style="color:rgba(158, 172, 196, 1);font-size:13px;">最后版本时间：</span>
                            <span style="color:rgba(0, 0, 0, 1);font-size:13px;">{{ proDetail.updateTime }}</span>
                        </div>
                        <div style="margin-top:24px;">
                            <span style="color:rgba(158, 172, 196, 1);font-size:13px;">{{ proDetail.isShare==0?'未分享':'分享' }}</span>
                        </div>
                        <div style="margin:24px 0">
                            <span style="color:rgba(158, 172, 196, 1);font-size:13px;">{{ proDetail.billingPolicy }}</span>
                        </div>
                        <div style="color:rgba(158, 172, 196, 1);font-size:13px;">
                            未公开
                        </div>
                    </div>
                    <div style="display:inline-block;width:20%;float:left">
                        <div>
                            <span style="color:rgba(158, 172, 196, 1);font-size:13px;">创建时间：</span>
                            <span style="color:rgba(0, 0, 0, 1);font-size:13px;">{{ proDetail.createTime }}</span>
                        </div>
                    </div>
                    <div style="width:10%;display:inline-block;float:left">
                        <div style="margin-top:85px;text-align:right">
                            <span @click="setWorkTime" style="display:inline-block;width:80px;height:32px;text-align:center;line-height:32px;background:rgba(34, 215, 187, 1);border-radius:8px;color:#fff;font-size:14px;cursor:pointer">去配置</span>
                        </div>
                        <div style="margin-top:18px;text-align:right">
                            <!-- <a-switch @change="changeSwitch(proDetail.shared)" :checked="proDetail.shared=='NO'?false:true" /> -->
                            <a-switch />
                        </div>
                    </div>
                </div>
                <div style="position:absolute;width:100%;height:68px;bottom:0px;background:rgba(244, 244, 245, 1);padding:16px 24px;">
                    <span style="margin-top:8px;float:left;">项目基本操作</span>
                    <div style="float:right;">
                        <span style="display:inline-block;width:100px;height:36px;text-align:center;line-height:36px;border:1px solid rgba(229, 229, 229, 1);background:#fff;color:rgba(212, 48, 48, 1);font-size:14px;border-radius:4px;cursor:pointer;" @click="confirm">删除项目</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="currentTab==7" class="dialogues">
            <div class="result-view">
                <div>
                    <a-row>
                        <a-col :span="5">
                            <div style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">名称查询：</div>
                            <a-input class="phone" style="min-width:195px;width:100%;max-width:220px;" v-model="inputName" placeholder="请输入" />
                        </a-col>
                        <a-col :span="6">
                            <div style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">类型：</div>
                            <a-select style="min-width:270px;width:100%;max-width:280px;" v-model="selectType" placeholder='请选择'>
                            <a-select-option value="2">
                                按次
                            </a-select-option>
                            <a-select-option value="3">
                                按天
                            </a-select-option>
                            </a-select>
                        </a-col>
                        <a-col :span="8">
                            <div class="title" style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">到期时间：</div>
                            <a-range-picker  v-model="dateList" :locale="locale" style="" format="YYYY-MM-DD HH:mm:ss" />
                        </a-col>
                        <a-col :span="5" style="padding-top:29px;text-align:right;">
                            <a-button @click="resetSource" style="margin-right:13px;border:1px solid rgba(34, 215, 187, 1);color:rgba(34, 215, 187, 1);width:80px;text-align:center">重置</a-button>
                            <a-button type="primary" @click="queryDataSource()" style="border:1px solid rgba(34, 215, 187, 1);background:rgba(34, 215, 187, 1);width:80px;text-align:center">查询</a-button>
                        </a-col>
                    </a-row>
                </div>
                <div class="operation" style="margin-top:24px;">
                    <div>
                        <span style="color:rgba(51, 51, 51, 1);font-size:16px;">查询结果：</span>
                        <span style="color:rgba(34, 215, 187, 1)">{{totalSource}}</span>
                        <a-button @click="goToMiddleCenter" type="primary" style="margin-right:8px;background:rgba(34, 215, 187, 1);border:1px solid rgba(34, 215, 187, 1);float:right">去购买</a-button>
                    </div>
                </div>
                <div style="clear:both"></div>
                <div class="table-content">
                    <a-table :data-source="packageSourceData" :pagination='false' :loading="ifShowLoadingSource" :rowKey="record => record.id">
                        <a-table-column key="orderId" title="订单id" data-index="orderId" />
                        <a-table-column key="name" title="资源包名称" data-index="name" />
                        <a-table-column key="type" title="类型" data-index="type" />
                        <a-table-column key="unit" title="单位" data-index="unit" />
                        <a-table-column key="total" title="总量" data-index="total" />
                        <a-table-column key="surplus" title="余量" data-index="surplus" />
                        <a-table-column key="startTime" title="生效时间" data-index="startTime" />
                        <a-table-column key="endTime" title="到期时间" data-index="endTime" />
                        <a-table-column key="status" title="状态" data-index="status">
                            <template slot-scope="text, record">
                            <span v-if="record.status==1">有效</span>
                            <span v-if="record.status==2">已停用</span>
                            </template>
                        </a-table-column>
                    </a-table>
                    <a-pagination
                        style="float:right;margin-top:16px"
                        v-model="currentPageSource"
                        :page-size-options="pageSizeOptionsSource"
                        :total="totalSource"
                        show-size-changer
                        :page-size="pageSizeSource"
                        @showSizeChange="onShowSizeChangeSource"
                        @change="onChangeSampleSource"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>
                    </a-pagination>
                </div>
            </div>
            <!-- <router-link target="_blank" rel="opener" to="/Communication" class="dialogBox">
            <a-icon style="z-index:1000;font-size:25px" type="message" />
            </router-link> -->
        </div>
        <div v-if="currentTab==8" class="dialogues">
            <div class="result-view">
                <div>
                    <a-row>
                        <a-col :span="8">
                            <div style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">资源包名称：</div>
                            <a-input class="phone" style="min-width:195px;width:100%;max-width:220px;" v-model="inputName" placeholder="请输入" />
                        </a-col>
                        <a-col :span="8">
                            <div style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">场景名称：</div>
                            <a-select style="min-width:270px;width:100%;max-width:280px;" v-model="selectType" placeholder='请选择场景'>
                                <a-select-option value="2">
                                    天
                                </a-select-option>
                                <a-select-option value="3">
                                    次
                                </a-select-option>
                            </a-select>
                        </a-col>
                        <a-col :span="8" style="padding-top:29px;text-align:right;">
                            <a-button @click="resetSource" style="margin-right:13px;border:1px solid rgba(34, 215, 187, 1);color:rgba(34, 215, 187, 1);width:80px;text-align:center">重置</a-button>
                            <a-button type="primary" @click="queryDataSource()" style="border:1px solid rgba(34, 215, 187, 1);background:rgba(34, 215, 187, 1);width:80px;text-align:center">查询</a-button>
                        </a-col>
                    </a-row>
                </div>
                <div class="operation" style="margin-top:24px;">
                    <div>
                        <span style="color:rgba(51, 51, 51, 1);font-size:16px;">查询数量：</span>
                        <span style="color:rgba(34, 215, 187, 1)">{{totalSource}}</span>
                    </div>
                </div>
                <div style="clear:both"></div>
                <div class="table-content">
                    <a-table :data-source="packageSourceData" :pagination='false' :loading="ifShowLoadingSource" :rowKey="record => record.id">
                        <a-table-column key="orderId" title="订单id" data-index="orderId" />
                        <a-table-column key="name" title="资源包名称" data-index="name" />
                        <a-table-column key="type" title="类型" data-index="type" />
                        <a-table-column key="unit" title="单位" data-index="unit" />
                        <a-table-column key="total" title="总量" data-index="total" />
                        <a-table-column key="surplus" title="余量" data-index="surplus" />
                        <a-table-column key="startTime" title="生效时间" data-index="startTime" />
                        <a-table-column key="endTime" title="到期时间" data-index="endTime" />
                        <a-table-column key="status" title="状态" data-index="status">
                            <template slot-scope="text, record">
                            <span v-if="record.status==1">有效</span>
                            <span v-if="record.status==2">已停用</span>
                            </template>
                        </a-table-column>
                    </a-table>
                    <a-pagination
                        style="float:right;margin-top:16px"
                        v-model="currentPageSource"
                        :page-size-options="pageSizeOptionsSource"
                        :total="totalSource"
                        show-size-changer
                        :page-size="pageSizeSource"
                        @showSizeChange="onShowSizeChangeSource"
                        @change="onChangeSampleSource"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>
                    </a-pagination>
                </div>
            </div>
            <!-- <router-link target="_blank" rel="opener" to="/Communication" class="dialogBox">
            <a-icon style="z-index:1000;font-size:25px" type="message" />
            </router-link> -->
        </div>
        <!-- tab1 -->
        <a-modal
            :mask-closable="true"
            title="项目名称"
            :visible="visible"
            @ok="handleOk1"
            @cancel="handleCancel1"
            okText="确认" cancelText="取消"
            >
            <div class="">
                <a-input v-model="newName" />
            </div>
        </a-modal>
        <a-modal
            :mask-closable="false"
            title="项目工作时间设定"
            :visible="workTimeModal"
            @ok="sureWorkTime"
            @cancel="cancelWorkTime"
            okText="确认" cancelText="取消"
            width="630px"
            >
            <div class="working-time-box">
                <a-checkbox-group v-model="itemDetail.weekList" @change="chooseWorkingTime">
                    <div class="checkbox-item">
                        <a-checkbox value="MONDAY">
                        周一
                        </a-checkbox>
                    </div>
                    <div class="checkbox-item">
                        <a-checkbox value="TUESDAY">
                        周二
                        </a-checkbox>
                    </div>
                    <div class="checkbox-item">
                        <a-checkbox value="WEDNESDAY">
                        周三
                        </a-checkbox>
                    </div>
                    <div class="checkbox-item">
                        <a-checkbox value="THURSDAY">
                        周四
                        </a-checkbox>
                    </div>
                    <div class="checkbox-item">
                        <a-checkbox value="FRIDAY">
                        周五
                        </a-checkbox>
                    </div>
                    <div class="checkbox-item">
                        <a-checkbox value="SATURDAY">
                        周六
                        </a-checkbox>
                    </div>
                    <div class="checkbox-item">
                        <a-checkbox value="SUNDAY">
                        周日
                        </a-checkbox>
                    </div>
                </a-checkbox-group>
                <div style="margin:16px 0;color:rgba(153, 153, 153, 1);font-size:12px;">
                    <span>时间段1：</span>
                    <a-time-picker style='width:240px;' placeholder='开始时间' v-model="itemDetail.timeQuantum1.startTime" format="HH:mm"/>
                    <span style="margin:0 2px;">~</span>
                    <a-time-picker style='width:240px;' placeholder='结束时间' v-model="itemDetail.timeQuantum1.endTime" format="HH:mm"/>
                </div>
                <div style="color:rgba(153, 153, 153, 1);font-size:12px;">
                    <span>时间段2：</span>
                    <a-time-picker style='width:240px;' placeholder='开始时间' v-model="itemDetail.timeQuantum2.startTime" format="HH:mm"/>
                    <span style="margin:0 2px;">~</span>
                    <a-time-picker style='width:240px;' placeholder='结束时间' v-model="itemDetail.timeQuantum2.endTime" format="HH:mm"/>
                </div>
                <div style="margin:16px 0;color:rgba(153, 153, 153, 1);font-size:12px;">
                    <span>时间段3：</span>
                    <a-time-picker style='width:240px;' placeholder='开始时间' v-model="itemDetail.timeQuantum3.startTime" format="HH:mm"/>
                    <span style="margin:0 2px;">~</span>
                    <a-time-picker style='width:240px;' placeholder='结束时间' v-model="itemDetail.timeQuantum3.endTime" format="HH:mm"/>
                </div>
                <div style="color:rgba(153, 153, 153, 1);font-size:12px;">
                    <span>时间段4：</span>
                    <a-time-picker style='width:240px;' placeholder='开始时间' v-model="itemDetail.timeQuantum4.startTime" format="HH:mm"/>
                    <span style="margin:0 2px;">~</span>
                    <a-time-picker style='width:240px;' placeholder='结束时间' v-model="itemDetail.timeQuantum4.endTime" format="HH:mm"/>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="screenModal" title="外链分享" footer='' width='720px'>
            <div class="share-modal modal-public">
                <div class="copy-link">
                    <a-input id="copyHtml1" readonly="readonly" :placeholder="linkUrl" />
                    <span @click="copyLink()">复制链接</span>
                </div>
            </div>
        </a-modal>
    </div>
</template>
  
<script>
    import moment from 'moment';
    import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
    import zhCN from 'ant-design-vue/es/locale-provider/zh_CN';
    export default {
        name: 'ProDetail',
        props: ['personalName'],
        data() {
            return {
                proDetail: '',
                currentTab: 1,
                visible: false,
                newName: '',
                projectId: '',
                workTimeModal: false,
                itemDetail: {
                    weekList: [],
                    timeQuantum1: {
                        startTime: "",
                        endTime: ""
                    },
                    timeQuantum2: {
                        startTime: "",
                        endTime: ""
                    },
                    timeQuantum3: {
                        startTime: "",
                        endTime: ""
                    },
                    timeQuantum4: {
                        startTime: "",
                        endTime: ""
                    },
                    callbackUrl: ''
                },
                currentWeekList: [],
                currentTimeQuantum1: '',
                currentTimeQuantum2: '',
                currentTimeQuantum3: '',
                currentTimeQuantum4: '',
                locale,
                zhCN,
                screenModal: false,
                linkUrl: '',
                // tab7
                ifShowPackage:true,
                inputName: '',
                selectType: undefined,
                dateList: [],
                currentPageSource: 1,
                packageSourceData: [],
                totalSource: 0,
                ifShowLoadingSource: false,
                pageSizeSource: 10,
                pageSizeOptionsSource: ['10', '20', '50', '100'],
                ifGpt: false,
            };
        },
        methods: {
            moment,
            queryProDetail() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/assistant/gptProjectDetail', 
                        params: {
                            projectId: this.projectId
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.proDetail = response.data.data
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            selectTab(data) {
                this.currentTab = data
            },
            changeProName(name) {
                this.visible = true
                this.newName = name
            },
            handleOk1() {
                this.axios.post('/api/project/name', {
                    id: this.projectId,
                    name: this.newName
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.proDetail.name = this.newName
                    }else{
                        this.$message.error(response.data.message);
                    }
                    this.visible = false
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            handleCancel1() {
                this.visible = false;
            },
            changeSwitch(item) {
                this.axios.post('/api/project/share', {
                    id: this.projectId,
                    operateType: item=='NO'?1:2
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('操作成功')
                        this.queryProDetail()
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            confirm() {
                this.$confirm({
                    title: '提示',
                    content: '确认要删除吗？',
                    okText: '确认',
                    cancelText: '取消',
                    icon: 'warning',
                    onOk: ()=> {
                    this.deleteProItem()
                    },
                })
            },
            deleteProItem() {
                this.axios.post('/api/project/delete', {
                    id: this.projectId,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$router.push('/MyProject')
                        this.$emit('changeAttention', false)
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            interactionLearn() {
                let routeData = this.$router.resolve({
                    path: '/Gpt',
                    query:{
                        projectId:this.projectId,
                        name:this.proDetail.name,
                        step: 3,
                        jumpSource: 'view'
                    }
                });
                window.open(routeData.href, '_blank');
            },
            // experienceLink() {
            //     let routeData = this.$router.resolve({path: '/Chat',query:{projectId:this.projectId,projectName:this.proDetail.name,des:this.proDetail.description}});
            //     window.open(routeData.href, '_blank');
            // },
            queryWorkTime() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/openApi/project/time', 
                        params: {
                            projectId: this.projectId
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.currentWeekList = response.data.data.weekList
                        this.currentTimeQuantum1 = response.data.data.timeQuantum1
                        this.currentTimeQuantum2 = response.data.data.timeQuantum2
                        this.currentTimeQuantum3 = response.data.data.timeQuantum3
                        this.currentTimeQuantum4 = response.data.data.timeQuantum4
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            judgeDay(day) {
                switch (day) {
                    case 'MONDAY':
                        return "周一"
                    case 'TUESDAY':
                    return "周二"
                    case 'WEDNESDAY':
                        return "周三"
                    case 'THURSDAY':
                        return "周四"
                    case 'FRIDAY':
                        return "周五"
                    case 'SATURDAY':
                        return "周六"
                    case 'SUNDAY':
                        return "周日"
                } 
            },
            setWorkTime() {
                this.workTimeModal = true
                this.axios(
                    {
                        method:'get',
                        url:'/api/openApi/project/time', 
                        params: {
                            projectId: this.projectId
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        let item = response.data.data
                        this.itemDetail.weekList = item.weekList?item.weekList:[]
                        this.itemDetail.timeQuantum1.startTime = item.timeQuantum1.startTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum1.startTime,"HH:mm")
                        this.itemDetail.timeQuantum1.endTime = item.timeQuantum1.endTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum1.endTime,"HH:mm")
                        this.itemDetail.timeQuantum2.startTime = item.timeQuantum2.startTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum2.startTime,"HH:mm")
                        this.itemDetail.timeQuantum2.endTime = item.timeQuantum2.endTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum2.endTime,"HH:mm")
                        this.itemDetail.timeQuantum3.startTime = item.timeQuantum3.startTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum3.startTime,"HH:mm")
                        this.itemDetail.timeQuantum3.endTime = item.timeQuantum3.endTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum3.endTime,"HH:mm")
                        this.itemDetail.timeQuantum4.startTime = item.timeQuantum4.startTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum4.startTime,"HH:mm")
                        this.itemDetail.timeQuantum4.endTime = item.timeQuantum4.endTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum4.endTime,"HH:mm")
                        this.itemDetail.callbackUrl = item.callbackUrl?item.callbackUrl:''
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            sureWorkTime() {
                this.workTimeModal = false
                this.axios.post('/api/openApi/project', {
                    id: this.projectId,
                    weekList: this.itemDetail.weekList,
                    timeQuantum1: {
                        startTime: moment(this.itemDetail.timeQuantum1.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum1.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum1.startTime, 'HH:mm').format('HH:mm'),
                        endTime: moment(this.itemDetail.timeQuantum1.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum1.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum1.endTime, 'HH:mm').format('HH:mm'),
                    },
                    timeQuantum2: {
                        startTime: moment(this.itemDetail.timeQuantum2.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum2.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum2.startTime, 'HH:mm').format('HH:mm'),
                        endTime: moment(this.itemDetail.timeQuantum2.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum2.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum2.endTime, 'HH:mm').format('HH:mm'),
                    },
                    timeQuantum3: {
                        startTime: moment(this.itemDetail.timeQuantum3.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum3.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum3.startTime, 'HH:mm').format('HH:mm'),
                        endTime: moment(this.itemDetail.timeQuantum3.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum3.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum3.endTime, 'HH:mm').format('HH:mm'),
                    },
                    timeQuantum4: {
                        startTime: moment(this.itemDetail.timeQuantum4.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum4.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum4.startTime, 'HH:mm').format('HH:mm'),
                        endTime: moment(this.itemDetail.timeQuantum4.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum4.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum4.endTime, 'HH:mm').format('HH:mm'),
                    },
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('配置成功');
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            cancelWorkTime() {
                this.workTimeModal = false
            },
            chooseWorkingTime(value) {
                this.itemDetail.weekList = value
            },
            newGpt() {
                this.$router.push({path: '/Gpt',query:{id:this.projectId}});
            },
            experienceLink() {
                let url = ''
                let protocol = window.location.protocol;
                let host = window.location.host;
                url = protocol + '//' + host + '/#/LiographicalLink?projectId=' + this.projectId+'&apply='+this.personalName+'邀请您在线体验Chatgpt助手场景《'+this.proDetail.name+'》，点击链接开始模拟对话'
                this.linkUrl = url
                this.screenModal = true
            },
            copyLink() {
                let url = ''
                let protocol = window.location.protocol;
                let host = window.location.host;
                url = protocol + '//' + host + '/#/LiographicalLink?projectId=' + this.projectId+'&apply='+this.personalName+'邀请您在线体验Chatgpt助手场景《'+this.proDetail.name+'》，点击链接开始模拟对话'
                let text = url
                let input = document.getElementById("copyHtml1");
                input.value = text; 
                input.select(); 
                document.execCommand("copy"); 
                this.$message.success('复制成功');
            },
            // tab7
            ifDisplay(){
                this.ifShowPackage = !this.ifShowPackage
            },
            onShowSizeChangeSource(current, pageSize) {
                this.currentPageSource = current
                this.pageSizeSource = pageSize;
                },
            onChangeSampleSource(current, pageSize) {
                this.currentPageSource = current
                this.pageSizeSource = pageSize
            },
            queryDataSource() {
                this.ifShowLoadingSource = true
                this.axios(
                    {
                    method:'get',
                    url:'/api/intelligence/resourcePackageList', 
                    params: {
                        name: this.inputName,
                        type: this.selectType==undefined?'':this.selectType,
                        startTime: this.dateList[0]==undefined?'':moment(this.dateList[0], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
                        endTime: this.dateList[1]==undefined?'':moment(this.dateList[1], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                    }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                    this.ifShowLoadingSource = false
                    this.packageSourceData = response.data.data.records
                    }else{
                    this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            resetSource() {
                this.inputName = ''
                this.dateList = []
                this.selectType = undefined
                this.queryDataSource()
            },
            goToMiddleCenter() {
                let host = window.location.host
                this.axios(
                    {
                        method:'get',
                        url:'/api/intelligence/superLoginUrl', 
                        params: {
                            hostName: host
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        let url = response.data.data.superLoginUrl
                        window.location.href = url + "&purchase=true"
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error);
                })
            },
        },
        mounted: function() {
            this.projectId = this.$route.query.id
            this.queryProDetail()
            this.queryWorkTime()
        },
    }
</script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  lang="less">
    .pro-detail{
        height: 100%;
        display: flex;
        flex-direction: column;
        .pro-info{
            display: flex;
            padding: 24px 16px;
            background: #fff;
            .item-img{
                width: 44px;
                margin-right: 10px;
            }
            .item-content{
                flex: 1;
                .pro-name{
                    color: rgba(18, 18, 18, 1);
                    font-size: 16px;
                    font-weight: bold;
                    i{
                        color:rgba(34, 215, 187, 1);
                        font-size:16px;
                        margin-left:16px;
                        cursor:pointer;
                        display: none;
                    }
                }
                .pro-name:hover{
                    i{
                        display: inline-block;
                    }
                }
                .pro-id{
                    color: rgba(158, 172, 196, 1);
                    font-size: 12px;
                    margin-top: 4px;
                }
            }
            .item-btn{
                width: 120px;
                height: 36px;
                font-weight: bold;
                cursor: pointer;
                margin-left: 12px;
                line-height: 36px;
                border: 1px solid rgba(34, 215, 187, 1);
                background: rgba(34, 215, 187, 0.08);
                font-size: 14px;
                border-radius: 4px;
                padding-left: 12px;
                color: rgba(34, 215, 187, 1);
                i{
                    margin-right: 8px;
                }
            }
            .item-btn2{
                border: 1px solid #2A82E4;
                background: #EEF5FD;
                color: #2A82E4;
                i{
                    margin-right: 8px;
                }
            }
        }
        .page-tab{
            background: #fff;
            border-bottom: 1px solid rgba(229, 231, 235, 1);
            div{
                display: inline-block;
                width: 124px;
                text-align: center;
                height: 40px;
                line-height: 40px;
                color: rgba(18, 18, 18, 1);
                cursor: pointer;
                i{
                    margin-right: 8px;
                }
            }
            div.active{
                color: rgba(34, 215, 187, 1);
                border-bottom: 3px solid rgba(34, 215, 187, 1);
            }
        }
        .tab-1{
            padding: 24px;
            .pro-basic-info{
                height: 168px;
                box-shadow: rgba(229, 231, 235, 1) solid 1px;
                border-radius: 8px;
                background: rgba(255, 255, 255, 1);
                padding: 24px;
                border: 1px solid rgba(229, 231, 235, 1);
                .basic-info-col-left{
                    border-right: 1px solid rgba(229, 229, 229, 1);
                    height: 100%;
                }
                .basic-info-col-right{
                    padding-left: 24px;
                }
                .basic-info-item{
                    margin-bottom: 16px;
                    font-size: 12px;
                    span:nth-child(1){
                        color: rgba(169, 169, 169, 1);
                        width: 100px;
                        display: inline-block;
                    }
                    span:nth-child(2){
                        color: rgba(0, 0, 0, 1);
                        width: 200px;
                        display: inline-block;
                    }
                    span:nth-child(3){
                        color: rgba(24, 144, 255, 1);
                        cursor: pointer;
                    }
                }
            }
            .pro-operation{
                margin-top: 24px;
                height: 124px;
                box-shadow: rgba(229, 231, 235, 1) solid 1px;
                border-radius: 8px;
                overflow: hidden;
                border: 1px solid rgba(229, 231, 235, 1);
                .pro-share{
                    height: 68px;
                    background: #fff;
                    padding: 24px;
                    .share-title{
                        color: rgba(18, 18, 18, 1);
                        font-size: 14px;
                    }
                    div{
                        float: right;
                        span{
                            margin-top: 4px;
                            float: right;
                            color: rgba(158, 172, 196, 1);
                            font-size: 14px;
                        }
                    }
                }
                .pro-btn-list{
                    height: 56px;
                    background: rgba(244, 244, 245, 1);
                    text-align: right;
                    padding: 10px 24px 0 0;
                    span{
                        display: inline-block;
                        margin-left: 12px;
                        background: #fff;
                        box-shadow: rgba(229, 229, 229, 1) solid 1px;
                        padding: 0 12px;
                        height: 36px;
                        line-height: 36px;
                        cursor: pointer;
                        color: rgba(18, 18, 18, 1);
                        font-size: 14px;
                    }
                    span:nth-child(3){
                        color: rgba(212, 48, 48, 1);
                    }
                }
            }
            .design-info{
                div{
                    i{
                        color: rgb(158, 172, 196);
                        font-size: 16px;
                    }
                    span{
                        color: rgb(158, 172, 196);
                        font-size: 13px;
                    }
                }
                .active{
                    i{
                        color: rgb(34, 215, 187);
                    }
                    span{
                        color: rgb(18, 18, 18);
                    }
                }
            }
        }
    }
    .working-time-box{
        .checkbox-item{
            display: inline-block;
            width: 82px;
        }
    }
    .path-manage{
        width: 100%;
        // height: 100%;
        flex: 1;
        overflow-y: auto;
        .path-manage-text{
            font-size: 18px;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
        }
        .editable-row-operations a {
            margin-right: 8px;
        }
        .path-manage-card1{
            background: #fff;
            height: 164px;
        }
        .path-manage-card2{
            margin-top: 24px;
            background: #fff;
            padding: 24px 24px 44px;
            margin-bottom: 6px;
            border: 1px solid rgba(229, 231, 235, 1);
            border-radius: 8px;
            .path-manage-table{
                padding-bottom: 24px;
                margin-top:15px;
                position: relative;
                td{
                    padding-top: 0px !important;
                    padding-bottom: 0px !important;
                    height: 48px !important;
                    line-height: 48px !important;
                }
                th{
                    height: 48px !important;
                    line-height: 48px !important;
                    padding-top: 0px !important;
                    padding-bottom: 0px !important;
                    background: rgba(240, 240, 240, 1) !important;
                }
            }
        }
    }
    #time-select-modal{
        div.box{
            width:180px;
            height:90px;
            display:inline-block;
            padding:20px 24px;
            border:1px solid rgba(238, 238, 238, 1);
            cursor:pointer;
            margin-right:24px;
            margin-bottom:20px;
            position:relative;
        }
        div.active{
            border:1px solid rgba(34, 215, 187, 1);
            box-shadow: rgba(34, 215, 187, 1) solid 1px;
        }
    }
    .dialogues1{
        padding: 16px 24px 24px;
        flex: 1;
        overflow-y: hidden;
        .left{
            float: left;
        }
        .right{
            float: right;
        }
        .condition{
        // border-radius: 4px;
        width: 100%;
        max-height: 337px;
        background: #fff;
        padding: 24px 40px;
        .title{
            // padding-bottom: 8px;
            span{
            font-size: 18px;
            color: #333;
            }
            i{
            cursor: pointer;
            // display: none;
            }
            i:hover{
            color: rgba(34, 215, 187, 1);
            }
        }
        .date{
            span.title{
            color: rgba(80, 80, 80, 1);
            font-size: 14px;
            display: inline-block;
            }
        }
        .info{
            span{
            margin-right: 8px;
            }
            .phone{
            width: 40%;
            }
        }
        .pro-tag{
            span{
            margin-right: 8px;
            }
        }
        .btn-group{
            button:nth-child(1):hover{
            color: rgba(34, 215, 187, 1) !important;
            }
            button span{
            margin-right: 0px !important;
            }
        }
        }
        .condition:hover{
        i{
            display: inline-block;
        }
        }
        .result-view1{
            border: 1px solid rgba(229, 231, 235, 1);
            margin-top: 16px;
            border-radius: 8px;
            flex: 1;
            background: #fff;
            padding: 24px;
            height: 100%;
            .operation{
                font-size: 14px;
                color: rgba(204, 204, 204, 1);
            }
            .table-content{
                padding-top: 15px;
                position: relative;
                th{
                height: 48px;
                line-height: 48px;
                background: #F0F0F0;
                padding-top:0px;
                padding-bottom:0px;
                }
                td{
                padding-top: 8px;
                padding-bottom: 8px;
                }
            }
        }
    }
    .output-detail{
        .ant-table-thead > tr > th{
        height: 48px;
        line-height: 48px;
        background: #F0F0F0 !important;
        padding-top:0px;
        padding-bottom:0px;
        }
        td{
        padding-top: 8px;
        padding-bottom: 8px;
        }
    }
    ::-webkit-scrollbar {
        display: none; /* Chrome Safari */
    }
    .data-view{
        background: rgba(250, 250, 250, 1);
        // display: flex;
        flex: 1;
        overflow-y: auto;
        .left-content{
        width: 240px;
        background: #fff;
        flex: 1;
        padding:24px 0;
        overflow-y: auto;
        padding-bottom: 50px;
        div{
            padding-left:24px;
        }
        ul{
            li{
            height: 48px;
            line-height: 48px;
            color:rgba(80, 80, 80, 1);
            padding-left:24px;
            padding-right:24px;
            cursor: pointer;
            width: 100%;
            overflow: hidden;
            font-size: 14px;
            }
            li.active{
            background: rgba(34, 215, 187, 0.1);
            color: rgba(34, 215, 187, 1);
            border-right: 2px solid rgba(34, 215, 187, 1);
            }
            li:hover{
            background: rgba(34, 215, 187, 0.1);
            }
        }
        }
        .center-content{
            flex: 1;
            .tag-manage{
                height: 53px;
                background: #fff;
                padding: 15px 0 0 24px;
                span{
                float: left;
                color: rgba(51, 51, 51, 1);
                font-size: 18px;
                }
                button{
                float: right;
                background: rgba(34, 215, 187, 1);
                border-color: rgba(34, 215, 187, 1);
                }
            }
            .card-body{
                width: 100%;
                overflow: auto;
                height: 100%;
                #card-body{
                // float: left;
                .card-content{
                    display:inline-block;
                    width: 311px;
                    height:168px;
                    float: left;
                    margin-top:16px;
                    overflow: hidden;
                    margin-right: 15px;
                    .card-foot{
                    color: rgba(204, 204, 204, 1);
                    font-size: 12px;
                    }
                    .isSelect{
                        background: #00BAAD !important;
                        color: #fff !important;
                        span{
                            color: #fff !important;
                        }
                        
                        }
                    }
                }
                #card-create{
                    background: rgba(250, 250, 250, 1);
                    border: none;
                }
            }
            
            .pro-content-text{
                font-size: 18px;
                font-weight: 600;
                border-bottom: 1px solid #ccc;
                height: 45px;
                line-height: 35px;
                margin-bottom: 24px;
            }
            .delete{
                position: absolute;
                right: 0px;
                top: 10px;
                cursor: pointer;
            }
            .card{
                width: 100%;
                cursor: default;
                height:162px;
                // margin-top: 24px;
                border-radius: 8px;
                position: relative;
                overflow: hidden;
                background: #fff;
                border: 1px solid rgba(229, 231, 235, 1);
                .new-card{
                display: inline-block;
                font-size: 30px;
                font-weight: bold;
                text-align: center;
                
                // line-height: 25px;
                }
                .new-card-text{
                font-size: 18px;
                margin-top: 10px;
                }
                .card-top:hover{
                .card-icon{
                    i{
                    cursor: pointer;
                    display: inline-block;
                    
                    }
                }
                }
                .card-top{
                height: 128px;
                padding: 16px 0px 0 20px;
                .card-title{
                    height: 26px;
                    margin-bottom:14px;
                    font-size: 16px;
                    color: rgba(18, 18, 18, 1);
                    font-weight: bold;
                }
                .card-data{
                    height: 20px;
                    font-size: 12px;
                    color: rgba(153, 153, 153, 1);
                }
                .card-num{
                    // height: 30px;
                    font-size: 18px;
                    color: rgba(255, 141, 26, 1);
                    // font-weight: bold;
                }
                .card-icon{
                    height: 40px;
                    font-size: 14px;
                    color: rgba(34, 215, 187, 1);
                    font-weight: bold;
                    float: right;
                    margin-right: 24px;
                    i{
                    cursor: pointer;
                    display: none;
                    
                    }
                }
                .card-proportion{
                    height: 20px;
                    font-size: 14px;
                    color: rgba(153, 153, 153, 1);
                }
                .card-proportion-num{
                    // height: 30px;
                    font-size: 24px;
                    color: rgba(78, 138, 250, 1);
                    // font-weight: bold;
                }
                }
            }
            .add-card{
                text-align: center;
                padding-top:40px;
            }
        }
        .right-content{
        width: 316px;
        height: 100%;
        background: #fff;
        padding: 24px;
        .title{
            color: rgba(80, 80, 80, 1);
            font-size: 14px;
            margin: 24px 0 10px 0;
        }
        .btn-group{
            margin-top: 24px;
            button{
            margin-left: 20px;
            }
        }
        }
        .right-content2{
        width: 316px;
        height: 100%;
        background: #fff;
        padding: 24px;
        .title{
            color: rgba(80, 80, 80, 1);
            font-size: 14px;
            margin: 24px 0 10px 0;
        }
        .btn-group{
            margin-top: 24px;
            button{
            margin-left: 20px;
            }
        }
        }
    }
    #save-btn{
        color: #fff !important;
    }
    .history-report{
        background: rgba(250, 250, 250, 1);
        // display: flex;
        overflow-y: auto;
        flex: 1;
        .left-content{
            width: 240px;
            background:#fff;
            height: 100%;
            overflow-y: auto;
            padding-bottom: 50px;
            .left-content-title{
                height: 60px;
                line-height: 60px;
                font-size: 18px;
                color: rgba(51, 51, 51, 1);
                padding-left: 24px;
                border-right: 1px solid #f0f2f3;
            }
            .left-content-ul{
                li{
                    height: 48px;
                    line-height: 48px;
                    width: 100%;
                    overflow: hidden;
                    cursor: pointer;
                    padding: 0 24px;
                    color: rgba(80, 80, 80, 1);
                }
                li:hover{
                    background: rgba(34, 215, 187, 0.1);
                    color: rgba(34, 215, 187, 1);
                }
                li.active{
                    color: rgba(34, 215, 187, 1);
                    background: rgba(34, 215, 187, 0.1);
                    border-right: 4px solid rgba(34, 215, 187, 1);
                }
            }
        }
        .right-content{
            // flex: 1;
            padding: 0px 0px 24px 0px;
            // height: 100%;
            // overflow-y: auto;
            .right-content-title{
                display: flex;
                height: 216px;
                width: 100%;
                .project-num{
                    float: left;
                    width: 600px;
                    height: 216px;
                    background: #fff;
                    border: 1px solid rgba(229, 231, 235, 1);
                    border-radius: 8px;
                    div{
                        text-align: center;
                    }
                }
            }
            .right-content-chart{
                height: 280px;
                margin: 16px 0;
                width: 100%;
                display: flex;
                .chart-card{
                    height: 100%;
                    background: #fff;
                    padding: 16px 0;
                    border-radius: 8px;
                    border: 1px solid rgba(229, 231, 235, 1);
                    .title{
                        span:nth-child(1){
                            color: rgba(51, 51, 51, 1);
                            font-size: 18px;
                            margin-right:4px;
                        }
                        span:nth-child(2){
                            color: rgba(153, 153, 153, 1);
                            font-size: 14px;
                        }
                    }
                }
                div.chart-card:nth-child(2){
                    margin-left: 16px;
                }
            }
            .right-content-content{
                height: 300px;
                background: #fff;
                width: 100%;
                padding: 24px 0;
                border-radius: 8px;
                border: 1px solid rgba(229, 231, 235, 1);
                .title{
                    span:nth-child(1){
                        color: rgba(51, 51, 51, 1);
                        font-size: 18px;
                        margin-right:4px;
                    }
                    span:nth-child(2){
                        color: rgba(153, 153, 153, 1);
                        font-size: 14px;
                    }
                }
            }
        }
    }
    .call-docking{
        background: #fafafa;
        flex: 1;
        overflow-y: auto;
        padding: 24px;
    }
    // tab3
    .channel-access{
        .sip-content{
            padding: 24px 0 0px 0px;
            display: flex;
            .tab{
                width: 112px;
                div{
                    padding-bottom: 4px;
                    color: rgba(80, 80, 80, 1);
                    margin-right: 24px;
                    cursor: pointer;
                    height: 37px;
                    line-height: 37px;
                    padding-left: 24px;
                }
                div.active{
                    color: rgba(34, 215, 187, 1);
                    border-right: 3px solid rgba(34, 215, 187, 1);
                    background: #E4F7F4;
                }
            }
            .list-content{
                flex: 1;
                .box{
                    padding: 16px 16px 0 16px;
                    width: 208px;
                    height: 92px;
                    background: #fff;
                    display: inline-block;
                    margin-right: 18px;
                    margin-bottom: 18px;
                    position: relative;
                    img{
                        width: 28px;
                        height: 28px;
                        float: left;
                        margin-right: 8px;
                    }
                    .info{
                        display: inline-block;
                        width: 100%;
                        .info-content{
                            color:rgba(80, 80, 80, 1);
                            font-size:14px;
                            margin-left:12px;
                            cursor: pointer;
                        }
                    }
                    .new-box{
                        display: none;
                        width: 201px;
                        height: 128px;
                        border-radius: 4px;
                        position: absolute;
                        overflow: hidden;
                        left: 74px;
                        top: 43px;
                        z-index: 10;
                        color: rgba(255, 255, 255, 1);
                        font-size: 13px;
                        line-height: 20px;
                        .in-new-box{
                            position: relative;
                            width: 100%;
                            height: 100%;
                            padding: 16px 8px 16px 16px;
                            box-sizing: border-box;
                            .box-mask{
                                width: 100%;
                                height: 100%;
                                background-color: rgba(8, 11, 15, 0.7);
                                position: absolute;
                                left: 0px;
                                top: 0px;
                            }
                            div.information{
                                z-index: 12;
                                span:nth-child(1){
                                    width: 65px;
                                    color: #fff;
                                    display: inline-block;
                                }
                            }
                        }
                    }
                }
                .info-content:hover{
                    .new-box{
                        display: block;
                    }
                }
            }
        }
        .tutorials{
            height: 110px;
            padding: 0px;
            border: 1px solid rgba(229, 231, 235, 1);
            border-radius: 8px;
            overflow: hidden;
            .brand-box{
                margin-top: 20px;
                padding: 0 24px;
                display: inline-block;
                float: left;
                img{
                    width: 120px;
                    margin-bottom: 8px;
                    height: 50px;
                    display: block;
                    // box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.1);
                }
                .carousel-pic{
                    .con{
                        float:left;
                        margin-right:24px
                    }
                    .con:nth-last-child(1){
                        margin-right: 0px;
                    }
                }
                
            }
        } 
    }
    .path-modal{
        .accout{
            div.item{
                margin-bottom: 12px;
                span{
                    display: inline-block;
                    width: 70px;
                    color: rgba(80, 80, 80, 1);
                    font-size: 14px;
                }
                input{
                    width: 310px;
                    height: 32px;
                }
            }
            div.btn-group{
                float: right;
                span{
                    width: 80px;
                    height: 32px;
                    display: inline-block;
                    border-radius: 4px;
                    line-height: 32px;
                    text-align: center;
                    font-size: 14px;
                    cursor: pointer;
                }
                span:nth-child(1){
                    background: #fff;
                    color: rgba(34, 215, 187, 1);
                    border: 1px solid rgba(34, 215, 187, 1);
                    margin-right: 16px;
                }
                span:nth-child(2){
                    background: rgba(34, 215, 187, 1);
                    color: #fff;
                }
            }
        }
        .loading{
            text-align: center;
            div{
                font-size: 16px;
                color: rgba(51, 51, 51, 1);
            }
            i{
                font-size: 24px;
                color: rgba(34, 215, 187, 1)
            }
        }
        .judge{
            text-align: center;
            img{
                width: 54px;
                height: 54px;
            }
            p{
                color: rgba(51, 51, 51, 1);
                font-size:16px;
            }
        }
        .path-activation{
            div.btn-group{
                float: right;
                span{
                    width: 80px;
                    height: 32px;
                    display: inline-block;
                    border-radius: 4px;
                    line-height: 32px;
                    text-align: center;
                    font-size: 14px;
                    cursor: pointer;
                }
                span:nth-child(1){
                    background: #fff;
                    color: rgba(34, 215, 187, 1);
                    border: 1px solid rgba(34, 215, 187, 1);
                    margin-right: 16px;
                }
                span:nth-child(2){
                    background: rgba(34, 215, 187, 1);
                    color: #fff;
                }
            }
            .twice-sure{
                i{
                    color: rgba(255, 170, 0, 1);
                    font-size: 22px;
                    margin-right: 16px;
                }
                span{
                    color: rgba(80, 80, 80, 1);
                    font-size: 18px;
                }
            }
            .title{
                padding:16px 0 30px 0;
                color: rgba(153, 153, 153, 1);
                font-size: 14px;
                padding-left: 37px;
            }
        }
    }
    .batch-loginout{
        .operate-btn{
            text-align: center;
            span{
                display: inline-block;
                width: 80px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                cursor: pointer;
                margin-right: 16px;
                border-radius: 4px;
            }
            span:nth-child(1){
                border: 1px solid rgba(34, 215, 187, 1);
                color: rgba(34, 215, 187, 1);
            }
            span:nth-child(2){
                color: #fff;
                background: rgba(34, 215, 187, 1);
            }
        }
    }
    .batch-operation{
        .title{
            color: rgba(80, 80, 80, 1);
            font-size: 14px;
            margin-bottom: 16px;
        }
        .select-box{
            height: 84px;
            padding: 12px 16px 0;
            border-radius: 4px;
            border: 1px solid rgba(238, 238, 238, 1);
            margin-bottom: 16px;
            cursor: pointer;
            .box-title{
                color: rgba(80, 80, 80, 1);
                font-size: 14px;
                margin-bottom: 6px;
            }
            .box-content{
                color: rgba(188, 188, 188, 1);
                font-size: 12px;
            }
        }
        .active{
            border: 1px solid rgba(34, 215, 187, 1);
        }
        .operate-btn{
            text-align: center;
            span{
                display: inline-block;
                width: 80px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                cursor: pointer;
                margin-right: 16px;
                border-radius: 4px;
            }
            span:nth-child(1){
                border: 1px solid rgba(34, 215, 187, 1);
                color: rgba(34, 215, 187, 1);
            }
            span:nth-child(2){
                color: #fff;
                background: rgba(34, 215, 187, 1);
            }
        }
    }
    .choose-path{
        .modal-choose-state{
            span{
                display: inline-block;
                margin-right: 24px;
                color: rgba(153, 153, 153, 1);
                font-size: 14px;
                cursor: pointer;
                padding-bottom: 4px;
            }
            span.active{
                color: rgba(34, 215, 187, 1);
                border-bottom: 3px solid rgba(34, 215, 187, 1);
            }
        }
        .operate-btn{
            text-align: center;
            span{
                display: inline-block;
                width: 80px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                cursor: pointer;
                margin-right: 16px;
                border-radius: 4px;
            }
            span:nth-child(1){
                border: 1px solid rgba(34, 215, 187, 1);
                color: rgba(34, 215, 187, 1);
            }
            span:nth-child(2){
                color: #fff;
                background: rgba(34, 215, 187, 1);
            }
        }
    }
    .batch-login{
        .modal-site{
            height: 60px;
            border-bottom: 1px solid rgba(238, 238, 238, 1);
            span.title{
                width: 70px;
                display: inline-block;
                color: rgba(80, 80, 80, 1);
                font-size: 14px;
            }
            span.tip{
                padding-left: 70px;
                color: rgba(212, 48, 48, 1);
                font-size: 12px;
            }
            input{
                width: 300px;
            }
        }
        .operate-btn{
            text-align: center;
            margin-top:12px;
            span{
                display: inline-block;
                width: 80px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                cursor: pointer;
                margin-right: 16px;
                border-radius: 4px;
            }
            span:nth-child(1){
                border: 1px solid rgba(34, 215, 187, 1);
                color: rgba(34, 215, 187, 1);
            }
            span:nth-child(2){
                color: #fff;
                background: rgba(34, 215, 187, 1);
            }
        }
    }
    // tab7
    .dialogues{
        padding: 24px 24px 24px;
        background: #fafafa;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        flex: 1;
        .condition{
        border-radius: 8px;
        width: 100%;
        max-height: 337px;
        background: #fff;
        padding: 16px 24px;
        border: 1px solid #e5e7eb;
        .left{
            float: left
        }
        .right{
            float: right;
        }
        .title{
            // padding-bottom: 8px;
            span{
            font-size: 18px;
            color: #333;
            }
            i{
            cursor: pointer;
            // display: none;
            }
            i:hover{
            color: rgba(34, 215, 187, 1);
            }
        }
        .date{
            span.title{
            color: rgba(80, 80, 80, 1);
            font-size: 14px;
            display: inline-block;
            }
        }
        .info{
            span{
            margin-right: 8px;
            }
            .phone{
            width: 40%;
            }
        }
        .pro-tag{
            span{
            margin-right: 8px;
            }
        }
        .btn-group{
            button:nth-child(1):hover{
            color: rgba(34, 215, 187, 1) !important;
            }
            button span{
            margin-right: 0px !important;
            }
        }
        }
        .condition:hover{
        i{
            display: inline-block;
        }
        }
        .result-view{
            flex: 1;
            background: #fff;
            padding: 16px 24px;
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            .operation{
                font-size: 14px;
                color: rgba(204, 204, 204, 1);
            }
            .table-content{
                padding-top: 15px;
                position: relative;
                th{
                height: 48px;
                line-height: 48px;
                background: #F0F0F0;
                padding-top:0px;
                padding-bottom:0px;
                }
                td{
                padding-top: 8px;
                padding-bottom: 8px;
                }
            }
        }
    }
    .output-detail{
        .ant-table-thead > tr > th{
        height: 48px;
        line-height: 48px;
        background: #F0F0F0 !important;
        padding-top:0px;
        padding-bottom:0px;
        }
        td{
        padding-top: 8px;
        padding-bottom: 8px;
        }
    }
    .copy-link{
        height: 62px;
        input{
            width: 464px;
            float: left;
            height: 40px;
        }
        span{
            float: left;
            display: inline-block;
            width: 88px;
            height: 40px;
            border: 1px solid rgba(121, 136, 155, 0.3);
            cursor: pointer;
            border-radius: 0px 4px 4px 0px;
            line-height: 40px;
            text-align: center;
        }
    }
</style>
  